import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';

/**
* CRUD service for cn.CommissionModel.
* Provides getObjectComponent() so the framework can resolve the object component
* for detail/edit mode via the 4-step click-chain (CONFIG-015).
* Component import is deferred via the entity-provider objectComponent[] to avoid
* circular dependencies — this service only handles the CRUD route.
*/
@Injectable({
    providedIn: 'root'
})
export class CommissionModelService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cn/commissionModels');
    }

    getObjectIcon(): string {
        return 'fa-solid fa-folder-tree';
    }

    /**
     * Human-readable entity labels [singular, plural].
     * Element [0] is the singular label consumed by the core CRUD dialog title
     * (MvsCoreService.getObjectLabels(objectType)?.[0]) so the create/edit dialog
     * shows "Provisionsmodell anlegen" / "Provisionsmodell bearbeiten" instead of
     * the literal field name. These are entity labels, NOT field names.
     */
    getObjectLabels(): string[] {
        return ['Provisionsmodell', 'Provisionsmodelle'];
    }

}
